import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { Box, Divider, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useRef } from "react";
import { useParams } from "react-router";
import { useReactToPrint } from "react-to-print";
import CommCard from "src/common/CommCard";
import { useApiQuery } from "src/hooks/useApiQuery";
import logo from "../../../../assets/image/bttf-logo.png";
import type { IVisitorMoneyReceipt } from "../type/visitorType";
const ViewVisitorMoneyReceipt = () => {
	const { id } = useParams();
	const { data } = useApiQuery<IVisitorMoneyReceipt>({
		endPoint: `/api/admin/visitor/money-receipt/${id}`,
		queryKeys: [id],
	});
	const componentRef = useRef(null);
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});
	return (
		<CommCard>
			<Box sx={{ height: "100vh" }}>
				<Typography
					variant='h6'
					sx={{
						fontWeight: "bold",
						color: "#064c8d",
						textAlign: "center",
						paddingY: "30px",
						display: "flex",
						alignContent: "center",
						justifyContent: "center",
						columnGap: 2,
					}}
				>
					Money Receipt Details{" "}
					<span onClick={() => handlePrint()}>
						<LocalPrintshopIcon />
					</span>
				</Typography>
				<Box
					ref={componentRef}
					sx={{
						width: "800px",
						paddingX: "20px",
						borderRadius: "16px",
						backgroundColor: "#fff",
						margin: "0 auto",
						boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
						fontFamily: "Arial, sans-serif",
						position: "relative",
						overflow: "hidden",
					}}
				>
					{/* Decorative Top Design */}
					<Box
						sx={{
							position: "absolute",
							top: 0,
							left: 0,
							width: "30%",
							height: "30px",
							backgroundColor: "#064c8d",
							clipPath: "polygon(0 0, 100% 0, 85% 100%, 0 100%)", // Adjust the bottom-right point inward
							zIndex: 1,
						}}
					/>
					<Box
						sx={{
							position: "absolute",
							top: 0,
							right: 0,
							width: "72%",
							height: "30px",
							backgroundColor: "#F09F22",
							clipPath:
								"polygon(6% 0, 100% 0, 100% 100%, 0 100%)",
							zIndex: 1,
						}}
					/>

					<Box
						sx={{
							position: "absolute",
							bottom: 0,
							left: 0,
							width: "72%",
							height: "30px",
							backgroundColor: "#F09F22", // Alternate color
							clipPath: "polygon(0 0, 100% 0, 93% 100%, 0 100%)",
							zIndex: 1,
						}}
					/>
					<Box
						sx={{
							position: "absolute",
							bottom: 0,
							right: 0,
							width: "30%",
							height: "30px",
							backgroundColor: "#064c8d", // Alternate color
							clipPath:
								"polygon(15% 0, 100% 0, 100% 100%, 0 100%)", // Mirrored version for bottom-right
							zIndex: 1,
						}}
					/>
					{/* ---------------CLIPPING PATH END-------------------- */}

					<Grid
						container
						// alignItems='start'
						sx={{ marginTop: "40px" }}
					>
						{/* Logo and Receipt Header */}
						<Grid item xs={3}>
							<Typography
								variant='h6'
								sx={{ fontWeight: "bold", color: "#064c8d" }}
							>
								<img
									src={logo}
									alt='Logo'
									width={60}
									// style={{ height: "50px" }}
								/>{" "}
							</Typography>
						</Grid>
						<Grid
							item
							xs={4}
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "end",
							}}
						>
							<Typography
								variant='h3'
								sx={{
									fontWeight: "bold",
									color: "#064c8d",
									textAlign: "end",
								}}
							>
								MONEY RECEIPT
							</Typography>
						</Grid>
						<Grid item xs={5} textAlign='right'>
							<Typography
								variant='h4'
								sx={{ fontWeight: "bold", color: "#064c8d" }}
							>
								Bangladesh Travel & Tourism Fair
							</Typography>
							<Typography variant='body2' sx={{ color: "#555" }}>
								📞+88 02-58154155 📧bttf@toab.org <br />
							</Typography>
							<Typography
								variant='body2'
								sx={{
									color: "#555",
									paddingLeft: "63px",
									// textAlign: "justify",
									fontSize: "11px",
								}}
							>
								105/E West Agargaon (2nd Floor), Agargaon
								Administrative Area, Sher-E-Bangla Nagar, 60
								Feet Road, Dhaka-1207, Bangladesh.
							</Typography>
						</Grid>
					</Grid>

					<Divider sx={{ margin: "10px 0" }} />

					{/* Receipt Details */}
					<Grid container spacing={2} alignItems='center'>
						<Grid item xs={3}>
							<Typography
								variant='body2'
								sx={{ display: "flex", alignItems: "center" }}
							>
								<strong>Receipt No:</strong>&nbsp;
								<div
									style={{
										borderBottom: "1px dotted #000",
										flex: 2,
									}}
								>
									{data?.money_receipt_no}
								</div>
							</Typography>
						</Grid>
						<Grid item xs={6}></Grid>
						<Grid item xs={3} textAlign='right'>
							<Typography
								variant='body2'
								sx={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<strong>Date:</strong>&nbsp;
								<div
									style={{
										borderBottom: "1px dotted #000",
										flex: 2,
										textAlign: "start",
									}}
								>
									{dayjs(data?.payment_date).format(
										"DD-MMM-YYYY"
									)}
								</div>
							</Typography>
						</Grid>
					</Grid>

					<Divider sx={{ margin: "10px 0" }} />

					{/* Received From */}
					<Typography
						variant='body1'
						sx={{ marginBottom: "10px", display: "flex" }}
					>
						Received with thanks from:&nbsp;
						<div
							style={{ borderBottom: "1px dotted #000", flex: 2 }}
						>
							{data?.visitor_name}
						</div>
					</Typography>

					{/* Payment Information */}
					<Typography
						variant='body1'
						sx={{ marginBottom: "10px", display: "flex" }}
					>
						<strong>Amount:</strong>&nbsp;
						<div
							style={{ borderBottom: "1px dotted #000", flex: 2 }}
						>
							{data?.paid_amount || 0} BDT
						</div>
					</Typography>

					{/* Account Information */}
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<Typography
								variant='body2'
								sx={{ display: "flex", alignItems: "center" }}
							>
								<strong>Account Name:</strong>&nbsp;
								<div
									style={{
										borderBottom: "1px dotted #000",
										flex: 2,
									}}
								>
									{data?.account_name}
								</div>
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								variant='body2'
								sx={{ display: "flex", alignItems: "center" }}
							>
								<strong>Branch:</strong>&nbsp;
								<div
									style={{
										borderBottom: "1px dotted #000",
										flex: 2,
									}}
								>
									{data?.account_branch}
								</div>
							</Typography>
						</Grid>
					</Grid>

					<Typography
						variant='body2'
						sx={{ marginBottom: "10px", display: "flex" }}
					>
						<strong>Bank Name:</strong>&nbsp;
						<div
							style={{ borderBottom: "1px dotted #000", flex: 2 }}
						>
							{data?.bank_name}
						</div>
						&nbsp; <strong>Cheque No:</strong>&nbsp;
						<div
							style={{ borderBottom: "1px dotted #000", flex: 2 }}
						>
							{data?.cheque_number}
						</div>
					</Typography>

					<Typography
						variant='body1'
						sx={{ marginBottom: "10px", display: "flex" }}
					>
						<strong>Note:</strong>&nbsp;
						<div
							style={{ borderBottom: "1px dotted #000", flex: 2 }}
						>
							{data?.note}
						</div>
					</Typography>
					{/* Footer */}
					<Divider sx={{ margin: "20px 0" }} />
					<Grid container sx={{ marginBottom: "40px" }}>
						<Grid item xs={4}>
							<Typography
								variant='body1'
								sx={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<strong>Received By:</strong>&nbsp;
								<div
									style={{
										borderBottom: "1px dotted #000",
										flex: 2,
									}}
								></div>
							</Typography>{" "}
						</Grid>
						<Grid item xs={4}></Grid>
						<Grid item xs={4} textAlign='right'>
							<Typography
								variant='body1'
								sx={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<strong>Authorized Signature:</strong>&nbsp;
								<div
									style={{
										borderBottom: "1px dotted #000",
										flex: 2,
									}}
								></div>
							</Typography>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</CommCard>
	);
};

export default ViewVisitorMoneyReceipt;
